(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = () => matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)').matches;
  const motion = () => reduced() ? 'instant' : 'smooth';
  const cache = new Map();
  const preload = src => {
    if (!cache.has(src)) { const image = new Image(); image.src = src; cache.set(src, image.decode().catch(() => {})); }
    return cache.get(src);
  };
  const enhanceStories = () => document.querySelectorAll('[data-atelier-story]').forEach(story => {
    if (story.dataset.enhanced) return;
    story.dataset.enhanced = 'true';
    const rail = story.querySelector('.ls-atelier-story__grid');
    const prev = story.querySelector('[data-story-prev]'), next = story.querySelector('[data-story-next]');
    const update = () => { prev.disabled = rail.scrollLeft < 5; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 5; };
    const move = direction => rail.scrollBy({ left: direction * (rail.querySelector('.ls-atelier-story__item').clientWidth + 13), behavior: motion() });
    prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, { passive: true }); new ResizeObserver(update).observe(rail); update();
  });
  if (!customElements.get('ls-atelier-card')) customElements.define('ls-atelier-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true; this.revision = 0;
      const gallery = this.querySelector('.ls-atelier-card__gallery');
      const portrait = this.querySelector('.ls-atelier-card__portrait');
      const count = this.querySelector('[data-gallery-count]');
      const first = this.querySelector('[data-gallery-first]'), second = this.querySelector('[data-gallery-second]');
      const view = index => {
        this.dataset.galleryView = index ? 'second' : 'first'; count.textContent = `${index ? '02' : '01'} / 02`;
        if (!desktop()) gallery.scrollTo({ left: index * gallery.clientWidth, behavior: motion() });
      };
      this.querySelector('[data-next-image]')?.addEventListener('click', () => view(desktop() ? Number(this.dataset.galleryView !== 'second') : Number(Math.round(gallery.scrollLeft / gallery.clientWidth) === 0)));
      portrait.addEventListener('pointerenter', () => { if (desktop()) view(1); });
      portrait.addEventListener('pointerleave', () => { if (desktop()) view(0); });
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); view(event.key === 'ArrowRight' ? 1 : 0); }
      });
      gallery.addEventListener('scroll', () => { if (!desktop()) count.textContent = `${Math.round(gallery.scrollLeft / gallery.clientWidth) ? '02' : '01'} / 02`; }, { passive: true });
      const observer = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) { second.loading = 'eager'; preload(second.src); observer.disconnect(); }
      }, { rootMargin: '400px' }); observer.observe(this);
      this.querySelectorAll('[data-color]').forEach(button => {
        button.addEventListener('pointerenter', () => { preload(button.dataset.model); preload(button.dataset.alternate); });
        button.addEventListener('click', async () => {
          const revision = ++this.revision;
          this.setAttribute('aria-busy', 'true');
          this.querySelectorAll('[data-color]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          await Promise.all([button.dataset.model, button.dataset.alternate, button.dataset.angle, button.dataset.front].map(preload));
          if (revision !== this.revision) return;
          const angle = this.querySelector('[data-angle-image]'), front = this.querySelector('[data-front-image]');
          this.classList.add('is-changing');
          first.src = button.dataset.model; second.src = button.dataset.alternate;
          first.alt = button.dataset.firstAlt; second.alt = button.dataset.secondAlt;
          this.querySelector('[data-caption-first]').textContent = button.dataset.firstCaption.split('·').pop().trim();
          this.querySelector('[data-caption-second]').textContent = button.dataset.secondCaption.split('·').pop().trim();
          angle.src = button.dataset.angle; front.src = button.dataset.front;
          angle.alt = `${this.dataset.title} ${button.dataset.color}, three-quarter product view`;
          front.alt = `${this.dataset.title} ${button.dataset.color}, alternate product view`;
          this.querySelector('.ls-atelier-card__view-controls').hidden = button.dataset.front === button.dataset.angle;
          delete this.querySelector('[data-product-stage]').dataset.activeView;
          this.querySelectorAll('[data-view]').forEach(other => other.setAttribute('aria-pressed', String(other.dataset.view === 'angle')));
          this.querySelectorAll('[data-shop-link], [data-gallery-link]').forEach(link => link.href = button.dataset.url);
          this.querySelectorAll('[data-gallery-link]').forEach((link, i) => link.setAttribute('aria-label', `${i ? 'Another view of' : 'Shop'} ${this.dataset.title} ${button.dataset.color}`));
          view(0); this.removeAttribute('aria-busy');
          requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-changing')));
          this.querySelector('[data-selection]').textContent = `${button.dataset.color} selected; photographs and product details updated.`;
        });
      });
      this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {
        this.querySelector('[data-product-stage]').dataset.activeView = button.dataset.view;
        this.querySelectorAll('[data-view]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      }));
    }
  });
  if (!customElements.get('ls-atelier-family')) customElements.define('ls-atelier-family', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const switchView = value => {
        this.querySelectorAll('[data-family-panel]').forEach(panel => panel.hidden = panel.dataset.familyPanel !== value);
        this.querySelectorAll('[data-family-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.familyView === value)));
        this.dataset.selectedType = value;
      };
      switchView('sun');
      this.querySelectorAll('[data-family-view]').forEach(button => button.addEventListener('click', () => switchView(button.dataset.familyView)));
    }
  });
  enhanceStories(); document.addEventListener('shopify:section:load', enhanceStories);
  const siteHeader = document.querySelector('.section-header');
  let headerFrames = 0;
  let headerAnimation = 0;
  const updateHeaderOffset = () => {
    if (siteHeader) {
      const visibleHeader = siteHeader.querySelector('.header-wrapper') || siteHeader;
      const bottom = Math.max(visibleHeader.offsetHeight, visibleHeader.getBoundingClientRect().bottom, 0);
      document.documentElement.style.setProperty('--ls-header-offset', `${bottom}px`);
    }
  };
  const trackHeader = () => {
    headerFrames = 16;
    if (headerAnimation) return;
    const tick = () => {
      updateHeaderOffset();
      if (--headerFrames > 0) headerAnimation = requestAnimationFrame(tick);
      else headerAnimation = 0;
    };
    headerAnimation = requestAnimationFrame(tick);
  };
  updateHeaderOffset();
  if (siteHeader && 'ResizeObserver' in window) new ResizeObserver(trackHeader).observe(siteHeader);
  if (siteHeader) new MutationObserver(trackHeader).observe(siteHeader, { attributes: true, attributeFilter: ['class', 'style'] });
  addEventListener('resize', trackHeader, { passive: true });
  addEventListener('scroll', trackHeader, { passive: true });
  const links = document.querySelectorAll('.ls-atelier-navigation [data-story-link]');
  if (links.length) {
    const sections = [...links].map(link => document.querySelector(link.getAttribute('href'))).filter(Boolean);
    const updateNavigation = () => {
      const current = [...sections].reverse().find(section => section.getBoundingClientRect().top < innerHeight * .45);
      links.forEach(link => { if (current && link.hash === `#${current.id}`) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
    };
    let queued = false;
    addEventListener('scroll', () => { if (!queued) { queued = true; requestAnimationFrame(() => { updateNavigation(); queued = false; }); } }, { passive: true }); updateNavigation();
  }
})();
